import React from 'react';
import { withRouter } from 'react-router';
import { NavLink } from 'react-router-dom';
import { Route, Switch, Redirect } from 'react-router-dom';
import { observer } from 'mobx-react';
// import { toJS } from 'mobx';
import store from '../../../../stores/store';
import * as local from '../../../../helpers/localStorage';

import './ContentMenu.css';
import { MemberPanel } from './Member/MemberPanel.js';
import VotePanel from '../../Vote/VotePanel';
import MeetingPanel from '../../Meeting/MeetingPanel';
import Governance from './Governance/Governance';
import { GOV_DEFAULT_TITLE, MEMBERS_DEFAULT_TITLE } from '../../../../helpers/constants';
import TaskPanel from '../../Task/TaskPanel';
import Spinner from '../../../../assets/images/spinner.svg';

const ContentMenu = observer(
    class ContentMenu extends React.Component {
        constructor() {
            super();

            this.state = {
                shouldDisplayGovTab: this.displayGovTab(),
                shouldDisplayTaskTab: this.displayTaskTab()
            };
            
        }
        
        shouldComponentUpdate(nextProps, nextState) {
            const url = store.companies.routeBeforeRefresh;

            if (
                nextState.shouldDisplayGovTab &&
                url !== '' &&
                url !== nextProps.location.pathname
            ) {
                store.companies.routeBeforeRefresh = '';
                nextProps.history.push(url);
            }
            return true;
        }

        displayGovTab = () => {
            if (store.groups.loadingGov) {
                if (store.groups.selectedGroupGovernanceCategories()) {
                    if (store.groups.selectedGroupGovernanceCategories().length > 0) {
                        return true;
                    }
                }
            }
            return false;
        };

        displayTaskTab = () => {        
            return store.tasks.shouldDisplayTaskTab;
        };

        getGovTitle = () => {
            //const govTitle = (this.state.shouldDisplayGovTab) ? store.groups.selectedGroup.GovernanceTitle : '';
            if (this.displayGovTab()) {
                // if(store.groups.selectedGroup !== null){
                return store.groups.selectedGroup.GovernanceTitle;
                // }
            }
            return '';
        };

        componentWillUpdate(nextProps, nextState) {
            if (this.state.shouldDisplayGovTab !== this.displayGovTab()) {
                this.setState({ shouldDisplayGovTab: this.displayGovTab() });
            }
            if (this.state.shouldDisplayTaskTab !== this.displayTaskTab()) {
                this.setState({ shouldDisplayTaskTab: this.displayTaskTab() });
            }
        }

        onClick = (type) => {
            //const reloadMeetings = store.meetings.fetch;
            switch (type) {
                case 'MTG': 
                    //store.meetings.set('loading', true);                 
                    //reloadMeetings();
                    break;
                case 'GOV':
                    break;
                case 'VOTE':
                   // store.votes.fetch();
                    break;
                case 'TASK':
                    break;
                case 'MEMB':
                    break;
                default:
            }
            setTimeout(this.refreshCarousels, 1000);
        };

        refreshCarousels() {
            if (store.companies.companyUpdateDelegate) store.companies.companyUpdateDelegate();
            if (store.companies.groupsUpdateDelegate) store.companies.groupsUpdateDelegate();
        }

        renderLink = linkName => {
            switch (linkName) {
                case 'MTG':
                    const meetingCount = local.countMeetingBadges();

                    if (store.meetings.displayMeetingTab) {
                        return (
                            <li onClick={this.onClick.bind(this, 'MTG')}>
                                <NavLink
                                    exact
                                    to="/dashboard/meetings"
                                    className={store.meetings.loading ? "nav-link text-center disable-link" : "nav-link text-center"}
                                    activeClassName="selected"                                    
                                >
                                    Meetings{' '}
                                    { !store.meetings.loading && meetingCount > 0 ? (
                                        <span className="badge badge-pill badge-notify">
                                            {meetingCount}
                                        </span>
                                    ) : null} 
                                    { store.meetings.loading &&
                                        <img alt="Loading..." src={Spinner} width="20px" />
                                    }
                                </NavLink>
                            </li>
                        );
                    }
                    return '';

                case 'GOV':
                    if (this.displayGovTab()) {
                        return (
                            <li onClick={this.onClick.bind(this, 'GOV')}>
                                <NavLink
                                    to="/dashboard/governance"
                                    className={store.companies.loadingGovernance ? "nav-link text-center disable-link" : "nav-link text-center"}
                                    activeClassName="selected"
                                >
                                    {store.groups.selectedGroup ? (
                                        store.groups.selectedGroup.GovernanceTitle
                                    ) : (
                                        GOV_DEFAULT_TITLE
                                    )}
                                    { !store.companies.loadingGovernance && store.groups.selectedGroup.NumberOfUnreadDocuments > 0 && (
                                        <span className="badge badge-pill badge-notify">
                                            {store.groups.selectedGroup.NumberOfUnreadDocuments}
                                        </span>
                                    )}
                                    { store.companies.loadingGovernance &&
                                        <img alt="Loading..." src={Spinner} width="20px" />
                                    }
                                </NavLink>
                            </li>
                        );
                    }
                    return '';
                case 'VOTE':              
                    const newVoteCount = store.votes.newVoteCount();
                    if (store.votes.shouldDisplayVoteTab) {
                        return (
                            <li onClick={this.onClick.bind(this, 'VOTE')}>
                                <NavLink
                                    id="votes-link"
                                    to="/dashboard/votes"
                                    className={store.votes.loading ? "nav-link text-center disable-link" : "nav-link text-center"}
                                    activeClassName="selected"
                                >
                                    Votes
                                    { !store.votes.loading && newVoteCount > 0 ? (
                                        <span className="badge badge-pill badge-notify">
                                            {newVoteCount}
                                        </span>
                                    ) : null}
                                </NavLink>
                                { store.votes.loading &&
                                    <img alt="Loading..." src={Spinner} width="20px" />
                                }
                            </li>
                        );
                    }
                    break;
                case 'TASK':
                    const numberOfAllNewTasks = store.tasks.numberOfAllNewTasks();
                    if (this.state.shouldDisplayTaskTab) {
                        return (
                            <li onClick={this.onClick.bind(this, 'TASK')}>
                                <NavLink
                                    to="/dashboard/tasks"
                                    className={store.tasks.loading ? "nav-link text-center disable-link" : "nav-link text-center"}
                                    activeClassName="selected"
                                >                                   
                                Tasks    
                                { !store.tasks.loading && numberOfAllNewTasks > 0 ? (
                                        <span className="badge badge-pill badge-notify">
                                            {numberOfAllNewTasks}
                                        </span>
                                    ) : null}                              
                                </NavLink>
                                { store.tasks.loading &&
                                    <img alt="Loading..." src={Spinner} width="20px" />
                                }
                            </li>
                        );
                    }
                    break;
                case 'MEMB':
                    if (store.groups.anyGroupSelected) {
                        return (
                            <li onClick={this.onClick.bind(this, 'MEMB')}>
                                <NavLink
                                    to="/dashboard/members"
                                    className={store.meetings.loading ? "nav-link text-center disable-link" : "nav-link text-center"}
                                    activeClassName="selected"
                                >
                                    {store.groups.selectedGroup ? (
                                        store.groups.selectedGroup.MemberTitle
                                    ) : (
                                        MEMBERS_DEFAULT_TITLE
                                    )}
                                    { store.meetings.loading &&
                                        <img alt="Loading..." src={Spinner} width="20px" />
                                    }
                                </NavLink>
                            </li>
                        );
                    }
                    break;

                default:
                    return '';
            }
        };

        redirectTo = () => {
            let to = '/dashboard/meetings';

            if (!store.meetings.displayMeetingTab) {
                if (
                    store.groups.selectedGroupGovernanceCategories() &&
                    store.groups.selectedGroupGovernanceCategories().length > 0
                ) {
                    to = '/dashboard/governance';
                } else if (store.votes.shouldDisplayVoteTab) {
                    to = '/dashboard/votes';
                } else if (this.state.shouldDisplayTaskTab) {
                    to = '/dashboard/tasks';
                } else {
                    to = '/dashboard/members';
                }
            }

           if(to === window.location.pathname) {
               return null
           }

           return <Redirect to={to} />
        };

        render() {
            const shouldDisplayVoteTab = store.votes.shouldDisplayVoteTab;           

            return (
                <span>
                    <div className="navbar mt-3 mb-3" id="content-navbar">
                        <nav className="">
                            <ul className="links links-left">
                                {this.renderLink('MTG')}
                                {this.renderLink('GOV')}
                                {this.renderLink('VOTE')}
                                {this.renderLink('TASK')}
                                {this.renderLink('MEMB')}
                            </ul>
                        </nav>
                    </div>
                    <Switch>
                        {/* <Route exact path="/dashboard/new" render={(props) => (<div>There is no new</div>)}/> */}
                        {this.displayGovTab() ? (
                            <Route
                                exact
                                path="/dashboard/governance"
                                render={props => (
                                    <Governance
                                        itemType={
                                            this.displayGovTab() ? (
                                                store.groups.selectedGroup.GovernanceTitle
                                            ) : (
                                                GOV_DEFAULT_TITLE
                                            )
                                        }
                                    />
                                )}
                            />
                        ) : null}
                        {shouldDisplayVoteTab ? (
                            <Route exact path="/dashboard/votes" component={VotePanel} />
                        ) : null}
                        {this.state.shouldDisplayTaskTab ? (
                            <Route exact path="/dashboard/tasks" component={TaskPanel} />
                        ) : null}
                        {store.meetings.displayMeetingTab ? (
                            <Route exact path="/dashboard/meetings" component={MeetingPanel} />
                        ) : null}                       
                        {store.groups.anyGroupSelected ? (
                            <Route
                                exact
                                path="/dashboard/members"
                                render={props => <MemberPanel />}
                            />
                        ) : null}
                        {
                            this.redirectTo()
                        }
                    </Switch>
                </span>
            );
        }
    },
);

export default withRouter(ContentMenu);



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Dashboard/components/ContentMenu.js